/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No1/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function No1({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/ExternalProfessionals/Content/ExternalProfessional/ContactInfo/No"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let externalProfessionalOtherPersonEmailsValueData = fromData.useDataFormat({ viewPath,
context: 'external_professional',
path: 'other.person.emails',
format: fromFormat.isEmptyList,
})
let externalProfessionalOtherPersonPhonesValueData = fromData.useDataFormat({ viewPath,
context: 'external_professional',
path: 'other.person.phones',
format: fromFormat.isEmptyList,
})
let aggregateData = fromAggregate.and(externalProfessionalOtherPersonEmailsValueData, externalProfessionalOtherPersonPhonesValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}